import { createFileRoute } from '@tanstack/react-router'

import { VendorList } from '@/features/vendor/VendorList'

export const Route = createFileRoute('/app/vendors/')({
  component: VendorsRoute,
})

/**
 * What a buyer already has.
 *
 * No check of its own for who is asking, for the reason `app.briefs.index.tsx`
 * records: everything under `/app` is behind one gate that answers that
 * question for all of them, and two answers to it would be two redirects
 * racing.
 */
function VendorsRoute() {
  return <VendorList />
}
